export default function IconPuzzle({ height, width, fill, blur, classname }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //   xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      role="icon"
      className={classname}
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 20 20"
    >
      <defs>
        <filter
          id="Shape"
          x="0"
          y="0"
          width="50.298"
          height="50.298"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feFlood floodColor={blur && "#00fe78"} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      {/* <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Shape)"> */}
      <path
        id="Shape-2"
        data-name="Shape"
        d="M14.053,14.053v5.465a.781.781,0,0,1-.781.781H.781A.781.781,0,0,1,0,19.518V.781A.781.781,0,0,1,.781,0H19.518A.781.781,0,0,1,20.3.781V13.272a.781.781,0,0,1-.781.781Zm0-1.561h4.684V7.807H14.053Zm0-6.246h4.684V1.561H14.053Zm-1.561,6.246V7.807H7.807v4.684Zm0-10.93H7.807V6.246h4.684ZM7.807,18.737h4.684V14.053H7.807ZM6.246,14.053H1.561v4.684H6.246Zm0-6.246H1.561v4.684H6.246Zm0-1.561V1.561H1.561V6.246Z"
        // transform="translate(15 15)"
        fill={fill ? fill : "#6C7270"}
      />
      {/* </g> */}
    </svg>
  );
}

//#00fe78
